<template>
  <div>
    <v-container
      v-if="
        !showCovidVaccine &&
        !showCovidUnder12Vaccine &&
        !showSeasonalFlu
      "
      fluid
      class="ma-0 pa-0 mb-16 jumbo-header"
      style="background-color: #F9F9F9;"
    >
      <v-row justify="center" align="center" class="fill-height">
        <v-col class="pt-8 pb-16">
          <v-container>
            <back-button
              class="my-8"
              @click.native="$router.go(-1)"
            ></back-button>
            <v-row>
              <v-col cols="12" lg="9">
                <!--
                <h2 class="mb-8 home-header-2">
                  Unfortunately you are not eligible to book using this service
                  at this time. You may be eligible to book at a local pharmacy
                  or your GP.
                </h2>
                -->
                <h2 class="mb-8 home-header-2">
                  Unfortunately, you are not eligible to book your vaccination
                  online.
                </h2>
                <p class="mb-4 home-header-3">
                  You will be able to book your vaccination when you are
                  invited to do so.
                </p>
                <p class="mb-4 home-header-3">
                  Thank you for your patience during this time.
                </p>
                <a
                    class="mb-8 home-header-3"
                    style="color: #007e93;"
                    href="https://vaccinations.hscni.net/booking/welcome"
                    target="_blank"
                >Read more about vaccination eligibility</a>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
    <v-row v-else justify="center">
      <v-col cols="12" class="pt-16">
        <v-container>
          <back-button @click.native="$router.go(-1)"></back-button>
          <v-row>
            <v-col cols="12" lg="6">
              <h3 class="mb-8 home-header-3">
                Which vaccinations are you booking today?
              </h3>
              <div class="mb-8">
                <v-checkbox
                  v-if="!isInfluenzaFlowDisabled && showSeasonalFlu"
                  v-model="bookingTypes"
                  v-on:change="onCheckboxGroupClicked()"
                  v-on:keyup.native.enter="
                    addRemoveBookingTypes('FLU');
                    onCheckboxGroupClicked();
                  "
                  label="Seasonal Flu"
                  value="FLU"
                  color="#006078"
                  class="ml-4 px-8 black--text"
                  :ripple="false"
                ></v-checkbox>
                <v-checkbox
                  v-if="!isCovidFlowDisabled && showCovidVaccine && !showCovidUnder12Vaccine"
                  v-model="bookingTypes"
                  v-on:change="onCheckboxGroupClicked()"
                  v-on:keyup.native.enter="
                    addRemoveBookingTypes('COVIDVACCINE');
                    onCheckboxGroupClicked();
                  "
                  label="COVID vaccine"
                  value="COVIDVACCINE"
                  color="#006078"
                  class="ml-4 px-8 black--text"
                  :ripple="false"
                ></v-checkbox>
                <v-checkbox
                  v-if="!isCovidFlowDisabled && showCovidUnder12Vaccine"
                  v-model="bookingTypes"
                  v-on:change="onCheckboxGroupClicked()"
                  v-on:keyup.native.enter="
                    addRemoveBookingTypes('COVIDVACCINE');
                    onCheckboxGroupClicked();
                  "
                  label="COVID vaccine"
                  value="COVIDVACCINEUNDER12"
                  color="#006078"
                  class="ml-4 px-8 black--text"
                  :ripple="false"
                ></v-checkbox>
              </div>
              <v-btn
                @click="onAfterContinueClicked"
                class="v-btn--primary"
                :disabled="!bookingTypes.length"
              >
                Continue
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import BackButton from '@/components/BackButton';
import moment from 'moment/moment';

export default Vue.extend({
  components: {
    BackButton
  },
  name: 'StepBookingTypes',
  data: () => ({
    bookingTypes: []
  }),
  computed: {
    ...mapGetters([
      'getDemographics',
      'getDateWhenLastDoseReceived',
      'getFrontlineHealthAndSocialCareWorker',
      'getIfCovidOrFluLetter',
      'getDateOfBirth',
      'getAge',
      'getAgeInMonths',
      'getFlowName',
      'isEligibleForInfluenzaVaccine',
      'isEligibleForCovidVaccine',
      'isEligibleForCovidUnder12Vaccine',
      'isInfluenzaFlowDisabled',
      'isCovidFlowDisabled',
      'isCovidEligible'
    ]),
    showSeasonalFlu() {
      return this.isEligibleForInfluenzaVaccine || this.getIfCovidOrFluLetter;
      // return this.isEligibleForInfluenzaVaccine;
    },
    showCovidVaccine() {
      if (this.isCovidFlowDisabled) {
        return false
      }

      if (this.ifOlderThan75By20270331) {
        return true
      }

      if (this.getIfCovidOrFluLetter){
        return true
      }

      if (
        this.getDemographics.includes('Care Home Resident') ||
        (
          this.getDemographics.includes('Immunosuppressed') &&
          this.getAgeInMonths >= 6
        )
      ) {
        return true
      }

      return false
    },
    showCovidUnder12Vaccine() {
      return this.getAgeInMonths >= 6 && 
        this.getAge < 12 && 
        (
          this.getIfCovidOrFluLetter ||
          this.getDemographics.includes('Immunosuppressed')
        )
    },
    ifMoreThan12WeeksSinceLastDose() {
      return moment()
        .startOf('day')
        .subtract(12, 'weeks') >= this.getDateWhenLastDoseReceived;
    },
    ifMoreThan8WeeksSinceLastDose() {
      return moment()
        .startOf('day')
        .subtract(8, 'weeks') >= this.getDateWhenLastDoseReceived;
    },
    ifMoreThan3MonthsSinceLastDose() {
      return moment()
        .startOf('day')
        .subtract(3, 'months') >= this.getDateWhenLastDoseReceived;
    },
    ifOlderThan74YearsAnd11Months() {
      const referenceDate = moment('1947-06-30', 'YYYY-MM-DD');
      return this.getDateOfBirth <= referenceDate;
    },
    ifWillTurn65BeforeApril2026() {
      const referenceDate = moment('2026-03-31', 'YYYY-MM-DD') // 31 March 2026
      const ageOnReferenceDate = referenceDate.diff(this.getDateOfBirth, 'years') // Calculate age on 31 March 2026
      return ageOnReferenceDate >= 65
    },
    ifWillTurn75BeforeApril2026() {
      const referenceDate = moment('2026-03-31', 'YYYY-MM-DD') // 31 March 2026
      const ageOnReferenceDate = referenceDate.diff(this.getDateOfBirth, 'years') // Calculate age on 31 March 2026
      return ageOnReferenceDate >= 75
    },
    ifOlderThan5YearsSince01_09() {
      const referenceDate = moment('2017-09-01', 'YYYY-MM-DD');
      return this.getDateOfBirth <= referenceDate;
    },
    ifOlderThan75By20270331() {
      const referenceDate = moment('2027-03-31', 'YYYY-MM-DD');
      const dob = moment(this.getDateOfBirth);
      const birthday75 = dob.clone().add(75, 'years');
      return referenceDate.isSameOrAfter(birthday75, 'day');
    }
  },
  methods: {
    addRemoveBookingTypes(value) {
      const index = this.bookingTypes.indexOf(value);
      if (index > -1) {
        this.bookingTypes.splice(index, 1);
      } else {
        this.bookingTypes.push(value);
      }
    },
    saveBookingTypes() {
      this.$store.commit('setBookingTypes', this.bookingTypes);
    },
    onCheckboxGroupClicked() {
      this.saveBookingTypes();
    },
    onAfterContinueClicked() {
      this.$gtag.event(`Booking type selected` + `${this.getFlowName}`, {})

      if (this.bookingTypes.includes('COVIDVACCINE') && !this.isCovidEligible) {
        this.$router.push('/booking/not-eligible-covid').catch(() => {})
      } else {
        this.$router.push('/booking/eligible').catch(() => {});
      }
    }
  }
});
</script>
